<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit">
      <div class="uk-grid" uk-grid>
        <div class="uk-width-1-1@m">
          <div class="uk-grid uk-form-horizontal" uk-grid>
            <div class="uk-width-1-2@m">
              <div class="uk-width-1-2@m uk-margin">
                <label class="uk-form-label" style="font-size: 1rem"
                  >Antwortzeit</label
                >
                <star-rating
                  :star-size="30"
                  :show-rating="false"
                  v-model="feedback.responseTime"
                ></star-rating>
              </div>
              <div class="uk-width-1-2@m uk-margin">
                <label class="uk-form-label" style="font-size: 1rem"
                  >Freundlichkeit</label
                >
                <star-rating
                  :star-size="30"
                  :show-rating="false"
                  v-model="feedback.friendliness"
                ></star-rating>
              </div>
              <div class="uk-width-1-2@m uk-margin">
                <label class="uk-form-label" style="font-size: 1rem"
                  >Beratung</label
                >
                <star-rating
                  :star-size="30"
                  :show-rating="false"
                  v-model="feedback.consultation"
                ></star-rating>
              </div>
            </div>
            <div class="uk-width-1-2@m">
              <div class="uk-width-1-2@m uk-margin">
                <label
                  ><input
                    type="checkbox"
                    class="uk-margin-small-right"
                    v-model="recommend"
                  />Weiterempfehlung</label
                >
              </div>
              <div class="uk-width-1-2@m uk-margin">
                <label
                  ><input
                    type="checkbox"
                    class="uk-margin-small-right"
                    v-model="vehicleAsDescribed"
                  />Fahrzeug wie beschrieben
                </label>
              </div>
              <div class="uk-width-1-2@m uk-margin">
                <label
                  ><input
                    type="checkbox"
                    class="uk-margin-small-right"
                    style="-moz-appearance: checkbox;"
                    v-model="vehicleBought"
                  />Fahrzeug gekauft</label
                >
              </div>
            </div>
          </div>
          <div class="uk-grid uk-grid-medium" uk-grid>
            <div class="uk-width-1-2@m">
              <label>Name*</label>
              <input
                class="uk-input uk-display-block"
                :class="{ 'uk-form-danger': errors.has('name') }"
                type="text"
                name="name"
                style="width:100%;"
                placeholder="Name*"
                v-validate="'required'"
                key="name"
                v-model="form.name"
              />
            </div>
            <div class="uk-width-1-2@m">
              <label>E-Mail*</label>
              <input
                class="uk-input uk-display-block"
                :class="{ 'uk-form-danger': errors.has('email') }"
                type="text"
                name="email"
                style="width:100%;"
                placeholder="E-Mail*"
                v-validate="'required'"
                key="email"
                v-model="form.email"
              />
            </div>
            <div class="uk-width-1-2@m uk-margin">
              <label>Nachricht</label>
              <textarea
                class="uk-textarea uk-display-block"
                rows="4"
                :class="{ 'uk-form-danger': errors.has('message') }"
                v-model="form.message"
                placeholder="Nachricht"
                name="message"
                key="message"
              ></textarea>
            </div>
            <div class="uk-width-1-1@m">
              <label :class="{ 'uk-form-danger': errors.has('privacy') }">
                <input
                  class="uk-checkbox"
                  v-validate="'required'"
                  name="privacy"
                  key="privacy"
                  type="checkbox"
                  v-model="form.privacy"
                />
                <span class="uk-text-small">
                  Mit der Verarbeitung meiner Daten, wie in der <a href='/datenschutz' target='_blank'>Einwilligungserklärung</a>  beschrieben stimme Ich zu. Ich kann diese Einwilligung jederzeit mit Wirkung für die Zukunft wiederufen.*
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="success" style="color:green;font-size:1.6rem;">
        Bewertung erfolgreich gesendet!
      </div>
      <button
        type="submit"
        class="uk-margin-top uk-button uk-button-secondary"
        @click.prevent="validateBeforeSubmit()"
        :disabled="sending"
      >
        <i :class="{ 'fa fa-spin fa-refresh': sending }"></i>
        Absenden
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

import StarRating from 'vue-star-rating'
export default {
  data() {
    return {
      feedback: {
        responseTime: 0,
        friendliness: 0,
        consultation: 0,
      },
      recommend: 0,
      vehicleAsDescribed: 0,
      vehicleBought: 0,
      privacy: false,
      form: {
        name: '',
        email: '',
        message: '',
      },
      success: false,
      sending: false,
      submitted: false,
      formErrors: {},
    }
  },
  components: {
    StarRating
  },

  methods: {
    validateBeforeSubmit() {
      this.submitted = true
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.submitted = false
          this.submit()
        }
      })
    },

    submit() {
      this.success = false
      this.sending = true
      axios
        .post('/wp-json/ansolution/v1/feedback', this.$data)
        .then((response) => {
          this.success = true
          this.sending = false
          this.name = ''
          this.email = ''
          this.message = ''
          this.data = {}
          this.$validator.reset()
          setTimeout(() => {
            this.success = false
          }, 4000)
        })
        .catch((error) => {
          this.sending = false
          this.success = false
          this.formErrors = error.response.data
        })
    },
  },
}
</script>
